module.exports = __webpack_public_path__ + "static/media/logo_white.5ab8ea87.svg";